import PaymentHelper from "@/utils/payment-helper"

export default class Gocardless {

    static get(pm, paymentData, store) {
        switch(pm.type) {
            case 'faster_payments':
            case 'pay_to':
            case 'sepa_instant_transfer':
                return Gocardless.openBanking(pm, paymentData, store);
        }
    }

    static openBanking(pm, paymentData, store) {
        const { company, first_name, last_name, email, routing_number, account_number, issuing_country, bank_code, bank_id, iban} = paymentData
        return {
            customer: {
                firstName: first_name,
                lastName: last_name,
                company,
                email,
                billingAddress: PaymentHelper.getCustomerBillingAddress(store)
            },
            bankAccount : {
                countryCode: issuing_country,
                accountNumber: account_number,
                routingNumber: routing_number,
                institutionId: bank_id,
                bankCode: bank_code,
                iban: iban
            }
        }
    }

}